const initialState = {
    all_manufacturers: [],
    all_return_orders: [],
    all_requests: [],
    all_labels: [],
    searchTerm: '',
    notifications: [],
    trackings: [],
    all_categories: [],
    all_subCategories: [],
    all_allowed_manufacturers: [],
    statsData: null,
    layout: localStorage.getItem('layoutPreference') || 'navbar',
    themeColor: localStorage.getItem('themeColor') || '#00509d'
};

const allReducers = (state = initialState, action) => {
    switch (action.type) {
        case "ALL_MANUFACTURERS":
            return {
                ...state,
                all_manufacturers: action.payload,
            };
        case "ALL_STATS":
            return {
                ...state,
                statsData: action.payload,
            };
        case "ALL_TRACKINGS":
            return {
                ...state,
                trackings: action.payload,
            };
        case "SEARCH_TERM":
            return {
                ...state,
                searchTerm: action.payload
            }
        case "ALL_RETURN_ORDERS":
            return {
                ...state,
                all_return_orders: action.payload
            }
        case "ALL_LEAVE_REQUESTS":
            return {
                ...state,
                all_requests: action.payload
            }
        case "ALL_LABELS":
            return {
                ...state,
                all_labels: action.payload
            }
        case "ALL_NOTIFICATIONS":
            return {
                ...state,
                notifications: action.payload
            }
        case "ALL_CATEGORIES":
            return {
                ...state,
                all_categories: action.payload
            }
        case "ALL_SUB_CATEGORIES":
            return {
                ...state,
                all_subCategories: action.payload
            }
        case "ALL_ALLOWED_MANUFACTURERS":
            return {
                ...state,
                all_allowed_manufacturers: action.payload
            }
        case "SET_LAYOUT":
            localStorage.setItem('layoutPreference', action.payload);
            return {
                ...state,
                layout: action.payload
            }
        case "SET_THEME_COLOR":
            localStorage.setItem('themeColor', action.payload);
            return {
                ...state,
                themeColor: action.payload
            }

        default:
            return state;
    }
};
export default allReducers;
